import BaseClient from '../base/baseClient';
import endpoint from '../../features/endPoints/ecommEndpoints';

const missionStatusClient = () => {

  const { get: getClient } = BaseClient();
  return getClient(
    process.env.REACT_APP_ECOMM_URL+endpoint.missionOutageFlag(),
    {},
    mapResponse,
    mapError
  );
};

const mapResponse = (response) => {
  return  response.data;
};

const mapError = (error) => {
  return error;
};

export default missionStatusClient;
